// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yxLt","right":"Footer_right__2Vw-a","buttons":"Footer_buttons__2l0kb"};